import { lazy, Suspense } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import PageLoader from '@/components/common/page-loader';
import ProtectedRoute from '@/components/common/protected-route';
import Layout from '@/components/layout';
import Toaster from '@/components/ui/sonner';
import { TooltipProvider } from '@/components/ui/tooltip';
import { useLiveStatus } from '@/hooks/use-live-status';
import { APP_ROUTES } from '@/lib/routes/app-routes';
import ChooseRolePage from '@/pages/choose-role';
import SignInPage from '@/pages/sign-in';

const Dashboard = lazy(() => import('@/components/active-trains-dashboard'));
const Archive = lazy(() => import('@/components/archive-trains-dashboard'));

export default function App() {
  useLiveStatus();

  return (
    <>
      <BrowserRouter>
        <TooltipProvider delayDuration={0}>
          <Routes>
            <Route path={APP_ROUTES.login} element={<SignInPage />} />
            <Route element={<ProtectedRoute />}>
              <Route path={APP_ROUTES.chooseRole} element={<ChooseRolePage />} />
              <Route element={<Layout />}>
                <Route
                  path={APP_ROUTES.dashboard}
                  element={
                    <Suspense fallback={<PageLoader />}>
                      <Dashboard />
                    </Suspense>
                  }
                />
                <Route
                  path={APP_ROUTES.archive}
                  element={
                    <Suspense fallback={<PageLoader />}>
                      <Archive />
                    </Suspense>
                  }
                />
                <Route path="*" element={<Navigate to={APP_ROUTES.dashboard} replace />} />
              </Route>
            </Route>
          </Routes>
        </TooltipProvider>
      </BrowserRouter>
      <Toaster />
    </>
  );
}
